import ColorJS from 'colorjs.io'
import { Color } from '..'
import { Theme } from '../types'

/**
 * Approximate value of WCAG 2.0 relative luminance recommendation.
 *
 * Background colors with a relative luminance above this threshold
 * should have a light text color; colors below it should have dark text.
 *
 * @see https://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
 */
const LUMINANCE_THRESHOLD = 0.179

export function textContrast(
  inputColor: string | null | undefined,
  theme: Theme = 'light'
): string {
  if (!inputColor) return 'transparent'

  try {
    const color = new ColorJS(inputColor)

    return color.luminance > LUMINANCE_THRESHOLD
      ? Color[theme]['Text/Primary']
      : Color[theme]['Text/Contrast']
  } catch (error) {
    if (error instanceof Error) {
      console.error(error.message)
    }
    return 'transparent'
  }
}
